import type { ReactNode } from 'react';
import React from 'react';
import classnames from 'clsx';
import { EditorState, RichUtils } from 'draft-js';

import { formatClassNames } from '@wix/editor-elements-common-utils';
import styles from '../button.scss';
import semanticClassNames from '../../../../RichTextBox.semanticClassNames';
import type { ExtendedToolbarChildrenProps } from '../../types';

export type InlineStyleButtonProps = ExtendedToolbarChildrenProps & {
  children: ReactNode;
  styleType: string;
};

export default (
  props: InlineStyleButtonProps & {
    dataTestId?: string;
  },
) => {
  const {
    styleType,
    children,
    setEditorState,
    getEditorState,
    dataTestId,
    lastSelectionBeforeKeyboardNavigation: lastSelection,
  } = props;

  const toggleStyle = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    const isKeyboardEvent = event.detail === 0;
    if (isKeyboardEvent) {
      event.stopPropagation();
    }
    const refEditorState =
      lastSelection && isKeyboardEvent
        ? EditorState.forceSelection(getEditorState(), lastSelection)
        : getEditorState();
    setEditorState(RichUtils.toggleInlineStyle(refEditorState, styleType));
  };

  const preventBubblingUp = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const selected =
    getEditorState().getCurrentInlineStyle().get(styleType) !== undefined;

  return (
    <div className={styles.buttonContainer}>
      <button
        className={styles.button}
        onMouseDown={preventBubblingUp}
        onClick={toggleStyle}
        type="button"
        data-testid={dataTestId}
        aria-pressed={selected ?? false}
      >
        <div
          className={classnames(
            styles.buttonContent,
            formatClassNames(semanticClassNames.icons),
            selected && styles.buttonContentSelected,
          )}
        >
          {children}
        </div>
      </button>
    </div>
  );
};
